
const compareItemChoiceItems = (itemChoiceItemsA, itemChoiceItemsB) => {
  if (!itemChoiceItemsA && !itemChoiceItemsB) return true;
  if (!itemChoiceItemsA || !itemChoiceItemsB) return false;
  if (itemChoiceItemsA.length !== itemChoiceItemsB.length) return false;

  return itemChoiceItemsA.every(itemChoiceItemA => {
    const { id, qty, itemChoices: itemChoicesA } = itemChoiceItemA
    const itemChoiceItemB = itemChoiceItemsB.find(i => i.id === id);
    
    if (!itemChoiceItemB) return false;
    if (qty !== itemChoiceItemB.qty) return false;

    const { itemChoices: itemChoicesB } = itemChoiceItemB
    return compareItemChoices(itemChoicesA, itemChoicesB);
  })
}

const compareItemChoices = (itemChoicesA, itemChoicesB) => {
  if (!itemChoicesA && !itemChoicesB) return true;
  if (!itemChoicesA || !itemChoicesB) return false
  if (itemChoicesA.length !== itemChoicesB.length) return false;

  return itemChoicesA.every(itemChoiceA => {
    const { id, itemChoiceItems: itemChoiceItemsA } = itemChoiceA
    const itemChoiceB = itemChoicesB.find(i => i.id === id);
    if (!itemChoiceB) return false;
    const { itemChoiceItems: itemChoiceItemsB } = itemChoiceB;
    return compareItemChoiceItems(itemChoiceItemsA, itemChoiceItemsB);
  })
}

export default compareItemChoices